/* =======================================================================
   Shop by Concern — tab switching + slider arrows
   Added by Cowork. Standalone: no dependency on native theme JS.

   All concerns are rendered server-side; switching a tab only toggles the
   `hidden` attribute, so there is no fetch delay and every concern's products
   stay in the HTML for SEO.
   ========================================================================== */
(function () {
  var SECTION = '.cns-section';

  function init(root) {
    if (!root || root.dataset.cnsReady === '1') return;
    root.dataset.cnsReady = '1';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;

    function panelOf(tab) {
      return root.querySelector('#' + CSS.escape(tab.getAttribute('aria-controls')));
    }

    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var p = panelOf(t);
        if (p) {
          if (on) p.removeAttribute('hidden');
          else p.setAttribute('hidden', '');
        }
      });
      if (focus) tab.focus();

      // keep the chosen tab in view on a scrolling strip
      var strip = tab.parentElement;
      if (strip && strip.scrollWidth > strip.clientWidth) {
        var tr = tab.getBoundingClientRect();
        var sr = strip.getBoundingClientRect();
        if (tr.left < sr.left || tr.right > sr.right) {
          strip.scrollTo({ left: tab.offsetLeft - strip.clientWidth / 2 + tab.offsetWidth / 2, behavior: 'smooth' });
        }
      }

      var panel = panelOf(tab);
      if (panel) {
        var rail = panel.querySelector('.cns__rail');
        // land at the start of the new concern, not wherever the last one was
        if (rail) { rail.scrollLeft = 0; refreshArrows(panel); }
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(tab);
        var next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') next = tabs[0];
        else if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) { e.preventDefault(); select(next, true); }
      });
    });

    /* ---------------------------------------------------------------- arrows */
    function refreshArrows(panel) {
      var rail = panel.querySelector('.cns__rail');
      var prev = panel.querySelector('[data-cns-dir="-1"]');
      var next = panel.querySelector('[data-cns-dir="1"]');
      if (!rail || !prev || !next) return;
      var max = rail.scrollWidth - rail.clientWidth - 2;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max;
    }

    root.querySelectorAll('.cns__panel').forEach(function (panel) {
      var rail = panel.querySelector('.cns__rail');
      if (!rail) return;

      rail.addEventListener('scroll', function () { refreshArrows(panel); }, { passive: true });

      if (typeof ResizeObserver === 'function') {
        // arrow state depends on how many cards fit, so recompute on resize
        new ResizeObserver(function () { refreshArrows(panel); }).observe(rail);
      } else {
        window.addEventListener('resize', function () { refreshArrows(panel); });
      }

      panel.querySelectorAll('[data-cns-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var first = rail.firstElementChild;
          if (!first) return;
          var gap = parseFloat(getComputedStyle(rail).columnGap) || 16;
          var step = first.getBoundingClientRect().width + gap;
          // move by one visible page, not a fixed pixel count
          var per = Math.max(1, Math.floor(rail.clientWidth / step));
          rail.scrollBy({ left: step * per * Number(btn.dataset.cnsDir) });
        });
      });

      refreshArrows(panel);
    });

    /* ------------------------------------------------- theme editor plumbing */
    document.addEventListener('shopify:block:select', function (e) {
      if (!root.contains(e.target)) return;
      var id = e.target.getAttribute('data-cns-block');
      if (!id) return;
      var tab = root.querySelector('[data-cns-block-tab="' + id + '"]');
      if (tab) select(tab, false);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(SECTION).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
